import { Component, computed, inject, input, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { RiskAssessmentReportIndicatorMitigationStatus } from "../../constants";
import { RiskAssessmentReportIndicatorMitigation } from "../../models";

@Component({
  standalone: false,
  selector: "app-risk-assessment-report-mitigation-print-view",
  templateUrl: "./risk-assessment-report-mitigation-print-view.component.html",
  styleUrls: ["./risk-assessment-report-mitigation-print-view.component.scss"],
})
export class RiskAssessmentReportMitigationPrintViewComponent {
  readonly mitigation = input.required<RiskAssessmentReportIndicatorMitigation>();

  private readonly sanitizer = inject(DomSanitizer);

  description = computed(() => this.getSafeHtml(this.mitigation().description));

  mapStatus = {
    [RiskAssessmentReportIndicatorMitigationStatus.COMPLETED]: {
      text: $localize`:@@riskassessment.mitigatedparentheses:(Mitigated)`,
      class: "mitigated",
      icon: "check",
    },
    [RiskAssessmentReportIndicatorMitigationStatus.NOT_APPLICABLE]: {
      text: $localize`:@@riskassessment.notapplicableparentheses:(Not applicable)`,
      class: "not-applicable",
      icon: "block",
    },
    null: {},
  };

  statusText = computed(() => {
    return this.mapStatus[this.mitigation().status].text;
  });

  statusClass = computed(() => {
    return this.mapStatus[this.mitigation().status].class;
  });

  private getSafeHtml(html: string): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, html);
  }
}
